import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'

class DataTableBloc {

    approveChannel = new Subject();
    revokeChannel = new Subject();
    exportChannel = new Subject();
    repository = new ApproveRepository()

    constructor() {
        this.approveChannel.next({status: apiResponse.INITIAL})
        this.revokeChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
    }

    fetchApprove = async (query) => {
        try {
            this.approveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, error: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRevoke = async (query) => {
        try {
            this.revokeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRevoke(query).then((result) => {
                this.revokeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.revokeChannel.next({status: apiResponse.ERROR, error: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, error: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default DataTableBloc